export default "__VITE_ASSET__Cst3MAFH__"